import React from 'react';
import './DeleteConfirmModal.css';

export default function DeleteConfirmModal({
  isOpen,
  title,
  message,
  onCancel,
  onConfirm,
  confirmText = 'Delete',
  confirmClass = 'btn-danger',
  icon = '⚠️'
}) {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-card animate-pop">
        <div className="confirm-modal-icon">{icon}</div>
        <h3 className="confirm-modal-title">{title || 'Confirm Deletion'}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className={`btn ${confirmClass}`} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
